import { useState, useCallback } from 'react';
import { message } from 'antd';
import materialReportApi, { F111 } from '../../../services/materialReportApi';

export default function useMaterialReport() {
  const [startCode, setStartCode] = useState('');
  const [endCode, setEndCode] = useState('zzzzzz');
  const [records, setRecords] = useState<F111[]>([]);
  const [loading, setLoading] = useState(false);
  const [queried, setQueried] = useState(false);

  // BR-02: auto-fill end code when start changes
  const onStartChange = useCallback((val: string) => {
    const v = val.toUpperCase();
    setStartCode(v);
    if (v) {
      const padded = (v + 'zzzzzz').substring(0, 6);
      setEndCode(padded);
    } else {
      setEndCode('zzzzzz');
    }
  }, []);

  const onEndChange = useCallback((val: string) => {
    setEndCode(val.toUpperCase());
  }, []);

  // BR-04: execute query
  const executeQuery = useCallback(async () => {
    setLoading(true);
    try {
      const res = await materialReportApi.queryRange(startCode, endCode);
      setRecords(res.data || []);
      setQueried(true);
      if ((res.data || []).length === 0) {
        message.info(res.message || '查無此資料!');
      } else {
        message.success(`查詢完成，共 ${res.total} 筆`);
      }
    } catch (err: any) {
      const errors = err?.response?.data?.errors;
      if (errors && Array.isArray(errors)) {
        errors.forEach((e: any) => message.error(e.message || e.Message));
      } else {
        message.error('查詢失敗');
      }
    } finally {
      setLoading(false);
    }
  }, [startCode, endCode]);

  const clearResults = useCallback(() => {
    setRecords([]);
    setQueried(false);
    setStartCode('');
    setEndCode('zzzzzz');
  }, []);

  return {
    startCode, endCode, records, loading, queried,
    onStartChange, onEndChange, executeQuery, clearResults,
  };
}
